import React from 'react';
import { Box } from '@mui/material';
import TeamLeadsMenu from './TeamLeadsMenu';
import TeamLeadsTable from './teamLeadsTable/TeamLeadsTable';
import TeamNotificationSnackbar from 'team/shared/components/notification/TeamNotificationSnackbar';

const TeamLeadsContent = ({
    filteredLeads,
    selectedLeadIds,
    isLoadingContacts,
    snackbar,
    onRefresh,
    onAddLeads,
    onExport,
    onLeadClick,
    onSelectLeads,
    onDateRangeChange,
    searchQuery,
    onSearchChange,
    onImportCSV,
    isExportRestricted,
    isCrmExportRestricted,
    onSnackbarClose,
    getSelectedLeads,
    filters,
    filterSearch,
    onFilterChange,
    onFilterSearchChange,
    onClearFilters
}) => {
    return (
        <Box sx={{ width: '100%', padding: 2 }}>
            <TeamLeadsMenu
                totalLeads={filteredLeads.length}
                onRefresh={onRefresh}
                onAddLeads={onAddLeads}
                onExport={onExport}
                leads={getSelectedLeads()}
                selectedCount={selectedLeadIds.length}
                onDateRangeChange={onDateRangeChange}
                searchQuery={searchQuery}
                onSearchChange={onSearchChange}
                onImportCSV={onImportCSV}
                isExportRestricted={isExportRestricted}
                isCrmExportRestricted={isCrmExportRestricted}
                filters={filters}
                filterSearch={filterSearch}
                onFilterChange={onFilterChange}
                onFilterSearchChange={onFilterSearchChange}
                onClearFilters={onClearFilters}
            />

            <Box sx={{ mt: 3 }}>
                <TeamLeadsTable
                    leads={filteredLeads}
                    onLeadClick={onLeadClick}
                    isLoading={isLoadingContacts}
                    onRefresh={onRefresh}
                    onSelectLeads={onSelectLeads}
                    selectedLeadIds={selectedLeadIds}
                />
            </Box>

            <TeamNotificationSnackbar
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                handleClose={onSnackbarClose}
            />
        </Box>
    );
};

export default TeamLeadsContent;

